import { FC, useState } from 'react';

import {
  Box,
  Text,
  Flex,
  Image,
  Center,
  Spinner,
  SimpleGrid,
} from '@chakra-ui/react';

import { motion } from 'framer-motion';

import { useQuery } from 'react-query';
import { getOrderImages } from 'api/order';

type Props = {
  orderId: string;
};

const MotionImage = motion(Image);

export const Pictures: FC<Props> = ({ orderId }) => {
  const [selected, setSelected] = useState('');

  const { data, isLoading } = useQuery(
    ['fetch-order-images', orderId],
    () => getOrderImages(orderId),
    { enabled: !!orderId },
  );

  const pictures = data?.proofOfDevliveries || [];

  const signatureFileURL = data?.signature || '';

  if (isLoading) {
    return (
      <Center flex={1} p="50px">
        <Spinner size="lg" />
      </Center>
    );
  }

  return (
    <Flex
      w="100%"
      mt="20px"
      flex={1}
      gap="20px"
      maxH="400px"
      overflow="auto"
      fontSize="14px">
      <Flex direction="column" gap="20px">
        <Box flex={1}>
          <Text mb="10px" fontWeight="600" color="#959595">
            Pictures
          </Text>
          {pictures.length > 0 ? (
            <SimpleGrid flex={1} columns={{ base: 2, md: 3 }} spacing="10px">
              {pictures.map((p) => (
                <Image
                  key={p}
                  src={p}
                  objectFit="cover"
                  h="100px"
                  w="100px"
                  borderRadius="10px"
                  overflow="hidden"
                  draggable={false}
                  onClick={() => {
                    setSelected((prev) => (prev === p ? '' : p));
                  }}
                  cursor="pointer"
                  opacity={selected === p ? 0.5 : 1}
                />
              ))}
            </SimpleGrid>
          ) : (
            <Center p="50px">
              <Text fontWeight="500" color="#959595">
                No Pictures uploaded
              </Text>
            </Center>
          )}
        </Box>

        <Box>
          <Text fontWeight="600" color="#959595">
            Signature
          </Text>
          {Boolean(signatureFileURL) ? (
            <Image
              mt="10px"
              src={signatureFileURL}
              w="100%"
              h="100px"
              objectFit="contain"
              blendMode="darken"
              draggable={false}
            />
          ) : (
            <Center h="100px">
              <Text fontWeight="500" color="#959595">
                No Signature uploaded
              </Text>
            </Center>
          )}
        </Box>
      </Flex>

      {pictures.length > 0 && (
        <Center flex={1}>
          <Center
            bg="#f1f1f1"
            h="300px"
            w="300px"
            borderRadius="10px"
            overflow="hidden">
            {Boolean(selected) ? (
              <MotionImage
                src={selected}
                objectFit="contain"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              />
            ) : (
              <Text>Select a picture to preview</Text>
            )}
          </Center>
        </Center>
      )}
    </Flex>
  );
};
